<form class="tw-grid tw-gap-4 tw-grid-cols-3 tw-mb-8" [formGroup]="searchForm" (ngSubmit)="search()">
  <div>
    <span class="p-input-icon-left tw-w-full">
      <i class="pi pi-search"></i>
      <input
        class="tw-w-full"
        formControlName="idSearchControl"
        name="idSearchControl"
        pInputText
        placeholder="ID"
        type="text" />
    </span>
  </div>

  <div class="tw-w-full">
    <span class="p-input-icon-left tw-w-full">
      <i class="pi pi-search"></i>
      <input
        class="tw-w-full"
        formControlName="nameSearchControl"
        name="nameSearchControl"
        pInputText
        placeholder="Nome"
        type="text"
        [maxlength]="50" />
    </span>
  </div>

  <div class="tw-w-full">
    <p-dropdown
      [options]="statusOptions"
      [showClear]="true"
      [style]="{ width: '100%' }"
      class="tw-w-full"
      formControlName="statusSearchControl"
      name="statusSearchControl"
      optionLabel="name"
      optionValue="id"
      placeholder="Status" />
  </div>

  <div class="tw-w-full">
    <p-calendar
      [iconDisplay]="'input'"
      [showIcon]="true"
      [style]="{ width: '100%' }"
      [readonlyInput]="true"
      dateFormat="dd/mm/yy"
      formControlName="startDateSearchControl"
      name="startDateSearchControl"
      placeholder="Data inicial" />
  </div>

  <div class="tw-w-full">
    <p-calendar
      [iconDisplay]="'input'"
      [showIcon]="true"
      [style]="{ width: '100%' }"
      [readonlyInput]="true"
      dateFormat="dd/mm/yy"
      [minDate]="searchForm.controls['startDateSearchControl'].value"
      formControlName="endDateSearchControl"
      name="endDateSearchControl"
      placeholder="Data final" />
  </div>

  <div class="tw-flex tw-gap">
    <p-button
      (onClick)="clearFilters()"
      icon="pi pi-filter-slash"
      pTooltip="Limpar filtros"
      severity="warning"
      tooltipPosition="bottom"
      [rounded]="true"
      [text]="true" />
    <p-button
      icon="pi pi-search"
      type="submit"
      pTooltip="Pesquisar"
      tooltipPosition="bottom"
      [rounded]="true"
      [text]="true" />
  </div>
</form>

<p-toast position="top-center" />
